<template>
  <div>
    <es-loader v-if="loading"/>
    <es-exception
      v-else-if="loadingError"
      margin="7.25rem"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else>
      <person-profile-associated-person-details
        :isRetired="isRetired"
        :isRecordRetired="isRecordRetired"
        :person="person"
        :retireReason="reason"
      />
      <person-profile-associated-location-info
        v-for="(item, index) in personLocations"
        :key="index"
        :isRetired="isRetired"
        :isRecordRetired="isRecordRetired"
        :person="person"
        :personLocations="item"
        style="margin-top: 1rem"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faPhoneRotary,
  faListAlt,
  faDatabase,
  faDiploma,
  faAddressBook,
} from '@fortawesome/pro-solid-svg-icons';
import { mapGetters } from 'vuex';
import EsLoader from '@/components/EsLoader.vue';
import EsException from '@/components/EsException.vue';
import PersonProfileAssociatedPersonDetails from '@/views/PersonProfile/PersonProfileAssociatedPersonDetails.vue';
import PersonProfileAssociatedLocationInfo from '@/views/PersonProfile/PersonProfileAssociatedLocationInfo.vue';
import FieldLabels from '@/mixins/FieldLabels';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faUser,
  faPhoneRotary,
  faListAlt,
  faDatabase,
  faDiploma,
  faAddressBook,
);

export default {
  mixins: [
    FieldLabels,
    PermissionManager,
  ],
  components: {
    EsLoader,
    EsException,
    PersonProfileAssociatedPersonDetails,
    PersonProfileAssociatedLocationInfo,
  },
  props: {
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
    reason: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      loadingError: false,
      personLocations: [],
    };
  },
  created() {
    this.onLoad();
  },
  computed: {
    ...mapGetters('lookups', [
      'activeGenders',
      'activeGrades',
      'activeStates',
      'activeRaces',
      'activeTitles',
    ]),
    isRecordRetired() {
      const { recordRetired } = this.$route.query;
      return recordRetired === 'true' || recordRetired === true;
    },
  },
  methods: {
    async getPersonLocations() {
      this.loading = true;
      this.loadingError = false;

      try {
        const { id, recordRetired } = this.$route.query;
        const isRecordRetired = recordRetired === 'true' || recordRetired === true;
        const baseUrl = `person/${id}/location`;
        const retiredBaseUrl = `retired-person/${id}/location`;

        const finalUrl = isRecordRetired ? retiredBaseUrl : baseUrl;
        const { data: response } = await axios.get(finalUrl);

        this.personLocations = this.groupByPersonType(response);
      } catch (error) {
        console.error('Error fetching locations:', error);
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    groupByPersonType(data) {
      const personLocations = data.reduce((acc, obj) => {
        const key = obj.personTypeName;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
      return personLocations;
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.getPersonLocations(),
        ]);
      } catch (err) {
        console.error('Unexpected error:', err);
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
  filters: {
  },
};
</script>

  <style lang="sass" scoped>
  </style>
